import { render, staticRenderFns } from "./WalletsNew.vue?vue&type=template&id=183967d3&"
import script from "./WalletsNew.vue?vue&type=script&lang=ts&"
export * from "./WalletsNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports